import { createContext } from "react";

export default createContext({
  primaryColor: "#294267" // default brand color
});